import { memo, useCallback, useState } from "react";

interface Props {}

export const Print = memo((props: Props) => {
  const [triggeredPrint, setTriggeredPrint] = useState(false);
  const print = useCallback(() => {
    if (triggeredPrint) return;
    setTriggeredPrint(true);
    setTimeout(() => {
      window.print();
      window.close();
    }, 1000);
  }, [triggeredPrint]);

  print();

  return null;
});
